/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { LoaderLayout } from "components/atoms/loader/LoaderLayout";
import { TheaterModeProvider } from "contexts/TheaterModeContext";

import StreamingV2 from "./StreamingV2";
import { useEventIdFromUrl } from "./enableNewPlayer";
import { useGetTHEOPlayerRuntime } from "./useGetTHEOPlayerRuntime";
import { useStreamingFeatureFlags } from "./useStreamingFeatureFlags";
import { useGetVideoGroupsSetResolver } from "./videojsComponent/multiAngle/useVideoGroupsSet";

import type { EventInfo } from "../../utility";
import type { EventVideo, THEOSetting } from "@spwn/types/firebase/firestore";
import type { Cookie } from "@spwn/types/functions";

export type StreamingSwitcherProps = {
  url: string;
  event: EventInfo;
  hasTicket: boolean;
  cookies: {
    [videoId: string]: {
      LL?: Cookie;
      default: Cookie;
    };
  };
  cookiesList?: {
    [videoId: string]: {
      [videoId: string]: {
        LL?: Cookie;
        default: Cookie;
      };
    }[];
  } | null;
  vid: string;
  vodSetting: THEOSetting;
  liveSetting: THEOSetting;
  eventVideoMap: { [videoId: string]: EventVideo };
  getStreamingKey?: () => Promise<void>;
  isDarkModeEnabled: boolean;
};

export const StreamingSwitcher = (props: StreamingSwitcherProps) => {
  const eventId = useEventIdFromUrl();
  const featureFlags = useStreamingFeatureFlags(eventId);
  const { event } = props;

  const theoPlayerRuntime = useGetTHEOPlayerRuntime();
  const getVideoGroupsSet = useGetVideoGroupsSetResolver();

  if (
    getVideoGroupsSet === undefined ||
    featureFlags === undefined ||
    theoPlayerRuntime === null
  ) {
    return <LoaderLayout />;
  }

  return (
    <TheaterModeProvider
      isHiddenStreamingComment={event.isHiddenStreamingComment}
    >
      <StreamingV2
        {...props}
        theoPlayerRuntime={theoPlayerRuntime}
        getVideoGroupsSet={getVideoGroupsSet}
        featureFlags={featureFlags}
      />
    </TheaterModeProvider>
  );
};
